// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"65e65b4d","239":"79c4205a","732":"1ba1033e"}[chunkId] + ".chunk.js";
};